import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AlertsService } from '@nx-ratenow/core/feature-alerts/data-access';
import { map, switchMap, withLatestFrom } from 'rxjs';
import { getAlert, selectedAlert } from './alert.actions';
import { AlertFacade } from './alert.facade';

@Injectable()
export class AlertEffects {
  selectorAlerts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAlert),
      withLatestFrom(this.alertFacade.alertData$),
      switchMap(([action, alert]) => {
        return this.alertService.getQnAlertById(alert.id).pipe(map((alertData) => selectedAlert({ alertData })));
      })
    )
  );

  constructor(
    private alertService: AlertsService,
    private actions$: Actions,
    private alertFacade: AlertFacade
  ) {}
}
